import {JOB_STATUS} from 'components/customer/Dashboard/LastJobButton';
import {useJobResetMutation} from 'components/customer/Job/store/jobApi';
import {
    useDialogContext,
    useJobContext,
    useNotificationContext,
} from 'contexts';
import {useCallback} from 'react';
import {genericMessageHandler} from 'shared/helpers';
import {PartialJob} from 'shared/types/PartialJob';

export const useResetJob = () => {
    const {job, setJob, setIsJobProcessing} = useJobContext() as PartialJob;
    const [resetJob] = useJobResetMutation();
    const {showDialog, hideDialog, updateOptions} = useDialogContext();
    const {notify} = useNotificationContext();

    const handleResetJob = useCallback(() => {
        if (job.status != JOB_STATUS.JOB_PENDING_CONFIRMATION) return true;

        return new Promise<boolean>((resolve) => {
            showDialog({
                title: 'Back to ordering',
                message:
                    'Are you sure you want to edit this job? this will unsubmit the job', // get proper wording for this
                hideYesButton: true,
                hideNoButton: true,
                buttons: [
                    {
                        show: true,
                        name: 'Yes edit job',
                        variant: 'danger',
                        controlledHideDialog: true,
                        action: async () => {
                            try {
                                updateOptions({
                                    buttons: [
                                        {
                                            disabled: true,
                                        },
                                    ],
                                });
                                await resetJob({
                                    jobId: job?.id,
                                    isReset: false,
                                });

                                // manually set job status so that customer
                                // does not land back in confirmation page
                                // as api request can take some time to finish
                                // after tag invalidation.
                                setIsJobProcessing(true);
                                setJob({
                                    status: JOB_STATUS.PROCESSING,
                                    accepted: false,
                                });

                                genericMessageHandler(
                                    notify,
                                    {message: 'Job has been reactivated'},
                                    'success'
                                );

                                resolve(true);
                            } catch (e) {
                                genericMessageHandler(notify, {
                                    message: 'Something went wrong',
                                });
                                resolve(false);
                            } finally {
                                hideDialog();
                            }
                        },
                    },
                    {
                        show: true,
                        name: 'Cancel',
                    },
                ],
            });
        });
    }, [resetJob, job, showDialog, hideDialog, setJob]);

    return {
        handleResetJob,
    };
};
